export default {
  nav: {
    home: "Hjem",
    categories: "Kategorier",
    guides: "Guides",
    buyingGuide: "Købsguide",
    faq: "FAQ",
  },
  hero: {
    badge: "Uafhængig AllChinaBuy-ressource",
    title: "AllChinaBuy Spreadsheet 2026",
    subtitle: "Udforsk organiserede AllChinaBuy-fund, produktkategorier, QC-referencer, forsendelsesguider og praktiske køberressourcer — alt på ét sted.",
    ctaSpreadsheet: "allchinabuy spreadsheet",
    ctaBuy: "Køb nu",
    ctaGuide: "Læs begynderguiden",
  },
  categories: {
    title: "Gennemse spreadsheet-kategorierne",
    subtitle: "Hop direkte til din favoritproduktkategori i det fulde spreadsheet.",
    browse: "Gennemse",
    shoes: "Sko",
    hoodies: "Hoodies/Sweatshirts",
    tshirts: "T-Shirts",
    jackets: "Jakker",
    pants: "Bukser/Shorts",
    headwear: "Hovedbeklædning",
    sets: "Sæt",
    underwear: "Undertøj/Underbukser",
    jersey: "Trøjer",
    accessories: "Tilbehør",
    bags: "Tasker",
    belts: "Bælter",
    perfumes: "Parfumer",
    other: "Andet",
  },
  why: {
    title: "Hvorfor bruge AllChinaBuy-spreadsheetet?",
    subtitle: "En enkel og organiseret måde at researche produkter på, før du køber.",
    f1t: "Organiserede fund",
    f1d: "Kuraterede produktlinks grupperet efter kategori, så du slipper for timevis af scrolling.",
    f2t: "QC-referencer",
    f2d: "Lær, hvad du skal tjekke i kvalitetskontrolfotos, før du sender.",
    f3t: "Forsendelsesklarhed",
    f3d: "Forstå vægt, volumetrisk vægt og hvordan du sænker forsendelsesomkostninger.",
    f4t: "Begyndervenligt",
    f4d: "Klare trin, der hjælper førstegangskøbere med at bestille trygt.",
  },
  guides: {
    title: "AllChinaBuy-guides og artikler",
    subtitle: "Uafhængige, originale guides til smartere indkøb.",
    readMore: "Læs artiklen",
  },
  faq: {
    title: "Ofte stillede spørgsmål",
    q1: "Hvad er AllChinaBuy-spreadsheetet?",
    a1: "Det er en fællesskabssamlet samling af kuraterede produktlinks og fund, organiseret efter kategori, som hjælper købere med at opdage varer og nemmere slå QC- og forsendelsesreferencer op.",
    q2: "Er denne side den officielle AllChinaBuy-hjemmeside?",
    a2: "Nej. Dette er en uafhængig informationsressource og er ikke tilknyttet AllChinaBuy. Priser, forsendelsespriser og politikker kan ændre sig — tjek altid før køb.",
    q3: "Fører kategori-knapperne til hoved-spreadsheetet?",
    a3: "Ja. Hver kategori-knap linker til den tilsvarende kategori på hoved-spreadsheet-siden.",
    q4: "Skal jeg have en konto for at gennemse?",
    a4: "Nej, der kræves ingen konto for at udforske guides og kategorilinks på denne side.",
    q5: "Kan jeg stole på forsendelses- og kuponoplysninger?",
    a5: "Oplysningerne på denne side er kun til reference. Bekræft altid aktuelle priser, kuponer og forsendelsespriser på den officielle side, før du bestiller.",
  },
  cta: {
    title: "Klar til at udforske det fulde spreadsheet?",
    subtitle: "Gå til hovedsiden for at gennemse det komplette, altid opdaterede produkt-spreadsheet.",
    button: "Åbn AllChinaBuy-spreadsheetet",
  },
  footer: {
    tagline: "En uafhængig ressource til AllChinaBuy-købere.",
    disclaimerTitle: "Ansvarsfraskrivelse",
    disclaimer: "Dette er en uafhængig informationsressource og er ikke tilknyttet AllChinaBuy. Priser, forsendelsespriser, kuponer, sælgere og politikker kan ændre sig. Tjek altid aktuelle oplysninger, før du køber. Alle eksterne links åbner i en ny fane.",
    rights: "© 2026 AllChinaBuy Spreadsheet. Alle rettigheder forbeholdes.",
  },
};